import { render, staticRenderFns } from "./dashboardBar.vue?vue&type=template&id=503f05c8&scoped=true&"
import script from "./dashboardBar.vue?vue&type=script&lang=js&"
export * from "./dashboardBar.vue?vue&type=script&lang=js&"
import style0 from "./dashboardBar.vue?vue&type=style&index=0&id=503f05c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503f05c8",
  null
  
)

export default component.exports